export { default as RewardPoints } from './RewardPoints';
